'use strict';

class FindMemberOrganisationResult {
    constructor() {
        this.resultContainer = document.querySelector("#list-view .fmo-result");
        this.selectedQuery = "";
        this.selectedBranch = "";
        this.onlygeo = false;
        this.baseUrl = this.getBaseUrl();

        document.addEventListener("fmo.searchTriggered", evt => {
            this.selectedQuery = evt.detail.query;
            this.onlygeo = evt.detail.onlygeo;
            this.loadResult();
        });

        document.addEventListener("fmo.branchSelected", evt => {
            this.selectedBranch = evt.detail.branch;
            this.loadResult();
        });

        document.addEventListener('click', function (event) {
            if (!event.target.matches('.fmo-container__listview .fmo-result li h2, .fmo-container__listview .fmo-result li svg')) return;

            var items = document.querySelectorAll(".fmo-container__listview .fmo-result li");
            [].forEach.call(items, item => {
                if (!item.isSameNode(event.target.parentNode)) {
                    item.classList.remove("open");
                }
            });
            event.target.parentNode.classList.toggle("open");

        }, false);
    }

    getBaseUrl() {
        const url = window.location.href.split('?')[0];
        return url.endsWith("/") ? url : `${url}/`;
    }

    loadResult() {
        if (this.selectedBranch || this.selectedQuery) {
            var url = this.baseUrl + "FindMemberOrganisations?branch=" + this.selectedBranch + "&query=" + encodeURIComponent(this.selectedQuery) + "&onlygeo=" + this.onlygeo;
            var tempContainer = "";
            document.dispatchEvent(new CustomEvent("fmo.loading"));
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    this.resultContainer.innerHTML = "";
                    if (data.result.length > 0) {
                        [].forEach.call(data.result, memberorganisation => {
                            tempContainer += this.resultTemplate(memberorganisation);
                        });
                    } else {
                        tempContainer += this.resultEmptyTemplate();
                    }
                    this.addToContainer(tempContainer);
                    document.dispatchEvent(new CustomEvent("fmo.resultLoaded", {
                        detail: { result: data.result, nonConcurrentGeoMatch: data.nonConcurrentGeoMatch }
                    }));
                    document.activeElement.blur();
                });
        } else {
            this.reset();
        }
    }

    addToContainer(html) {
        this.resultContainer.innerHTML += html.trim();
    }

    resultTemplate(memberorganisation) {
        var template = `<li>
            <h2>${memberorganisation.name} ${memberorganisation.fairTransport ? (`<div class="fmo__fairtransport"></div>`) : `` }</h2>
            <address>
                <span><strong>Adress:</strong>${memberorganisation.address}</span>`;
        if (memberorganisation.phone) {
            template += `<span><strong>Telefon:</strong><a href="tel:${memberorganisation.phone}">${memberorganisation.phone}</a></span>`;
        }
        if (memberorganisation.webpageUrl) {
            template += `<span><strong>Hemsida:</strong><a href="${memberorganisation.webpageUrl}" target="_blank">${memberorganisation.webpageUrl}</a></span>`;
        }
        template += `
            </address>
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="23" cy="23" r="22" stroke="#910068" stroke-width="2"/>
            <path d="M29.7 21.7L23.7 27.7C23.5 27.9 23.3 28 23 28C22.7 28 22.5 27.9 22.3 27.7L16.3 21.7C15.9 21.3 15.9 20.7 16.3 20.3C16.7 19.9 17.3 19.9 17.7 20.3L23 25.6L28.3 20.3C28.7 19.9 29.3 19.9 29.7 20.3C30.1 20.7 30.1 21.3 29.7 21.7Z" fill="#910068"/>
            </svg>
        </li>`;
        return template;
    }

    resultEmptyTemplate() {
        return `<li class="fmo__no-result"><p>Tyvärr kunde vi inte hitta något medlemsföretag som matchar din sökning.</p></li>`;
    }

    resultNoSearchTemplate() {
        return `<li class="fmo__no-result"><p>Du har ännu inte gjort någon sökning. Använd filtrering och sökfunktionen ovan för att hitta de medlemsföretag du letar efter.</p></li>`;
    }

    reset() {
        this.selectedQuery = "";
        this.resultContainer.innerHTML = "";
        this.addToContainer(this.resultNoSearchTemplate());
        document.dispatchEvent(new CustomEvent("fmo.resultReset"));
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new FindMemberOrganisationResult();
});